import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Home from '@/pages/Home';
import AboutUs from '@/pages/AboutUs';
import Projects from '@/pages/Projects';
import ProjectDetail from '@/pages/ProjectDetail';
import Testimonials from '@/pages/Testimonials';
import NewsMedia from '@/pages/NewsMedia';
import SocialActivities from '@/pages/SocialActivities';
import InstallApp from '@/pages/InstallApp';
import ContactUs from '@/pages/ContactUs';
import SignIn from '@/pages/SignIn';
import SignUp from '@/pages/SignUp';
import QRCodePage from '@/pages/QRCodePage';
import AdminLogin from '@/pages/admin/Login';
import AdminDashboard from '@/pages/admin/Dashboard';
import AdminProjects from '@/pages/admin/Projects';
import AdminTeam from '@/pages/admin/Team';
import AdminTestimonials from '@/pages/admin/Testimonials';
import AdminNewsMedia from '@/pages/admin/NewsMedia';
import AdminSocialActivities from '@/pages/admin/SocialActivities';
import AdminInquiries from '@/pages/admin/Inquiries';
import AdminLayout from '@/layouts/AdminLayout';
import PublicLayout from '@/layouts/PublicLayout';
import DashboardLayout from '@/layouts/DashboardLayout';
import DashboardHome from '@/pages/dashboard/DashboardHome';
import UserManagement from '@/pages/dashboard/UserManagement';
import AdminWorkbooks from '@/pages/dashboard/AdminWorkbooks';
import TicketsPage from '@/pages/dashboard/TicketsPage';
import DocumentsPage from '@/pages/dashboard/DocumentsPage';
import LeadsPage from '@/pages/dashboard/LeadsPage';
import SalesPipeline from '@/pages/dashboard/SalesPipeline';
import AnalyticsDashboard from '@/pages/dashboard/AnalyticsDashboard';
import ExcelReports from '@/pages/dashboard/ExcelReports';
import DMHierarchy from '@/pages/dashboard/DMHierarchy';
import TeamHierarchy from '@/pages/dashboard/TeamHierarchy';
import ContestsPage from '@/pages/dashboard/ContestsPage';
import CMSManagement from '@/pages/dashboard/CMSManagement';
import ReportIndexPage from '@/pages/dashboard/ReportIndexPage';
import AttendanceModule from '@/pages/dashboard/AttendanceModule';
import DashboardGateway from '@/pages/dashboard/DashboardGateway';
import EmailPage from '@/pages/dashboard/EmailPage';
import LocationTrackingPage from '@/pages/dashboard/LocationTrackingPage';
import VehicleDashboard from '@/pages/dashboard/VehicleDashboard';
import MessagingCenter from '@/pages/dashboard/MessagingCenter';
import CMDDashboard from '@/pages/dashboard/CMDDashboard';
import CertificatesPage from '@/pages/dashboard/CertificatesPage';
import { AuthProvider } from '@/contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/news-media" element={<NewsMedia />} />
            <Route path="/social-activities" element={<SocialActivities />} />
            <Route path="/install" element={<InstallApp />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/qr-code" element={<QRCodePage />} />
          </Route>
          
          {/* CRM Dashboard Routes */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<Navigate to="main" replace />} />
            <Route path="main" element={<DashboardHome />} />
            <Route path="checklist" element={<DashboardGateway />} />
            <Route path="cms" element={<CMSManagement />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="workbooks" element={<AdminWorkbooks />} />
            <Route path="leads" element={<LeadsPage />} />
            <Route path="pipeline" element={<SalesPipeline />} />
            <Route path="analytics" element={<AnalyticsDashboard />} />
            <Route path="excel" element={<ExcelReports />} />
            <Route path="hierarchy" element={<TeamHierarchy />} />
            <Route path="contests" element={<ContestsPage />} />
            <Route path="report-index" element={<ReportIndexPage />} />
            <Route path="attendance" element={<AttendanceModule />} />
            <Route path="email" element={<EmailPage />} />
            <Route path="location" element={<LocationTrackingPage />} />
            <Route path="tickets" element={<TicketsPage />} />
            <Route path="documents" element={<DocumentsPage />} />
            <Route path="vehicle" element={<VehicleDashboard />} />
            <Route path="messaging" element={<MessagingCenter />} />
            <Route path="cmd" element={<CMDDashboard />} />
            <Route path="certificates" element={<CertificatesPage />} />
            <Route path="team" element={<DashboardHome />} />
            <Route path="customers" element={<DashboardHome />} />
            <Route path="properties" element={<DashboardHome />} />
            <Route path="settings" element={<DashboardHome />} />
          </Route>
          
          <Route path="/admin/login" element={<AdminLogin />} />
          
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="team" element={<AdminTeam />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="news-media" element={<AdminNewsMedia />} />
            <Route path="social-activities" element={<AdminSocialActivities />} />
            <Route path="inquiries" element={<AdminInquiries />} />
          </Route>
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;